"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Action
var ActionType;
(function (ActionType) {
    ActionType["EMAIL"] = "email";
    ActionType["PUSH"] = "push";
    ActionType["SMS"] = "sms";
    ActionType["JOB"] = "job";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
// Action Raws
var JobStatus;
(function (JobStatus) {
    JobStatus["PENDING"] = "pending";
    JobStatus["SUCCESS"] = "success";
    JobStatus["FAIL"] = "fail";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
